import * as jQuery from 'jquery';
var $ = jQuery;
export function verticalStatsWidgetScripts() {
    $(document).ready(function () {
        // Count-up animation for stats numbers
        var animateCountUp = function (element, start, end, duration, hasDecimal) {
            var range = end - start;
            var increment = range / (duration / 16); // 60fps
            var current = start;
            var timer = setInterval(function () {
                current += increment;
                if ((increment > 0 && current >= end) || (increment < 0 && current <= end)) {
                    current = end;
                    clearInterval(timer);
                }
                // Format to 1 decimal place if the target has a decimal, otherwise round to integer
                if (hasDecimal) {
                    element.textContent = current.toFixed(1);
                }
                else {
                    element.textContent = Math.round(current).toString();
                }
            }, 16);
        };
        // Trigger fade-in animations immediately on page load for this widget
        var verticalStatsWidget = document.querySelectorAll('.rmff-vertical-stats-widget');
        verticalStatsWidget.forEach(function (widget) {
            var fadeInElements = widget.querySelectorAll('.fade-in-up');
            fadeInElements.forEach(function (element, index) {
                // Add staggered delay based on position
                var delay = 250 + (index * 150);
                setTimeout(function () {
                    element.classList.add('fade-in-up--visible');
                }, delay);
            });
        });
        // Trigger count-up animation immediately on page load
        var statNumbers = document.querySelectorAll('.rmff-vertical-stats-number');
        statNumbers.forEach(function (number, index) {
            var element = number;
            // Check if already animated
            if (element.classList.contains('animated')) {
                return;
            }
            element.classList.add('animated');
            var targetCountStr = element.getAttribute('data-count') || '0';
            var targetCount = parseFloat(targetCountStr);
            var hasDecimal = targetCountStr.includes('.') && targetCount % 1 !== 0;
            // Start animation after a delay (matching fade-in timing)
            setTimeout(function () {
                animateCountUp(element, 0, targetCount, 2000, hasDecimal); // 2 second animation
            }, 400 + (index * 150));
        });
    });
}
